import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: 'https://us.i.posthog.com',
  defaults: '2025-05-24',
  autocapture: {
    dom_event_allowlist: ['click'],
    element_allowlist: [
      'a',
      'button',
      'form',
      'input',
      'select',
      'textarea',
      'label',
    ],
  },
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider
      apiKey="phc_9Y89IFRrbIcwDw4mMpGCXM5kY1Fv4LnFpFciVkN2gxl"
      options={options}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//this is a test
